// extracted by mini-css-extract-plugin
export default {"bort":"Bort_bort__ivS8n","active":"Bort_active__Htj+W"};